import { APIMethod, fetchData } from "@client";

export async function getPdfPrinterVersionQuery(company, project, projectHash, versionKey, presetId) {
  const res = await fetchData(`/project/print/${company}/${project}/${projectHash}/${versionKey}`,
    APIMethod.GET,
    {
      params: {
        preset: presetId,
      },
      mapRequestKeysToSnakeCase: false,
    }
  );
  return res?.results;
}
